import { render, staticRenderFns } from "./ConversationContainerV2.vue?vue&type=template&id=3b0f5028&scoped=true"
import script from "./ConversationContainerV2.vue?vue&type=script&lang=js"
export * from "./ConversationContainerV2.vue?vue&type=script&lang=js"
import style0 from "./ConversationContainerV2.vue?vue&type=style&index=0&id=3b0f5028&prod&lang=scss&scoped=true"
import style1 from "./ConversationContainerV2.vue?vue&type=style&index=1&id=3b0f5028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f5028",
  null
  
)

export default component.exports